/* ============================================================================
   HISTORIAL DE VENTA DEL ITEM — Portal Kennedy
   ---------------------------------------------------------------------------
   El equivalente al "Sales Analysis Report by Item (Detailed)" de SAP, pero
   contestando ademas lo que el reporte de SAP no dice: QUIEN lo compro.

   Una fila por documento: factura o nota de credito, cliente, vendedor, fecha,
   cantidad, precio y importe. Las notas de credito salen en negativo, igual
   que en SAP (las lineas CN del reporte), y restan en el total: un articulo
   que se vende 50 y se devuelve 10 vendio 40.

   PERMISOS
     - La pantalla es para vendedores, gerencia y administracion.
     - La utilidad y el % solo los ve quien puede ver margenes (la misma regla
       de Consulta de inventario: administracion, Gady y Henry). Es informacion
       de costos y no tiene que estar delante de todo el equipo de ventas.

   Prefijo `hvi`.
============================================================================ */

var HVI_ITEM='', HVI_ROWS=[], HVI_NOMBRE='', HVI_COSTO=0;
var HVI_ANO='', HVI_Q='', HVI_ORDEN='fecha';

// ── Utilidades ──────────────────────────────────────────────────────────────
function hviEsc(s){
  return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function hviNum(v){ var n=Number(v); return isFinite(n)?n:0; }
function hviN(v,d){
  return hviNum(v).toLocaleString('en-US',{minimumFractionDigits:d||0,maximumFractionDigits:d||0});
}
function hviMon(v){
  return '$'+hviNum(v).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
}
function hviFecha(f){
  var p=String(f||'').slice(0,10).split('-');
  return p.length===3 ? (p[2]+'/'+p[1]+'/'+p[0]) : '';
}

function hviRol(){
  try{ return String((typeof CU!=='undefined'&&CU&&CU.rol)||'').toLowerCase(); }
  catch(e){ return ''; }
}
function hviPuedeVer(){
  return ['admin','administrador','gerencia','vendedor'].indexOf(hviRol())>=0;
}
// La misma regla que Consulta de inventario, para no tener dos criterios
// distintos sobre quien ve costos en el mismo portal.
function hviVerMargen(){
  if(typeof cinvVerMargen==='function') return cinvVerMargen();
  var u='';
  try{ u=String((CU&&(CU.username||String(CU.email||'').split('@')[0]))||'').toLowerCase(); }catch(e){}
  return ['admin','administrador','gerencia'].indexOf(hviRol())>=0
      || ['gady','henry'].indexOf(u)>=0;
}


/* ══════════════════════════════════════════════════════════════════════════
   CARGA
   ══════════════════════════════════════════════════════════════════════════ */

async function hviAbrir(itemcode){
  if(!hviPuedeVer()){ alert('No disponible para tu usuario.'); return; }
  HVI_ITEM=String(itemcode||''); HVI_ROWS=[]; HVI_ANO=''; HVI_Q=''; HVI_ORDEN='fecha';
  if(!HVI_ITEM) return;

  var prev=document.getElementById('hvi-ov'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='hvi-ov';
  ov.style.cssText='position:fixed;inset:0;background:var(--bg,#f5f5f7);z-index:14400;'
    +'overflow-y:auto;-webkit-overflow-scrolling:touch';
  ov.innerHTML='<div style="padding:40px;text-align:center;color:var(--text3);font-size:13px">'
    +'Buscando las ventas de '+hviEsc(HVI_ITEM)+'\u2026</div>';
  document.body.appendChild(ov);
  document.body.style.overflow='hidden';

  try{ await hviCargar(); }
  catch(e){
    ov.innerHTML='<div style="padding:40px;text-align:center;color:var(--red);font-size:13px">'
      +'No se pudo cargar el historial: '+hviEsc(e.message||e)
      +'<br><br><button class="btn btn-sm" onclick="hviCerrar()">Cerrar</button></div>';
    return;
  }
  hviPintar();
}
function hviCerrar(){
  var o=document.getElementById('hvi-ov'); if(o) o.remove();
  document.body.style.overflow='';
}

async function hviCargar(){
  var en=encodeURIComponent(HVI_ITEM);
  var sel='select=docnum,docdate,docduedate,cardcode,cardname,quantity,price,linetotal,'
    +'nombrevendedor,slpcode,dscription';

  var r=await Promise.all([
    q('facturas', sel+'&itemcode=eq.'+en+'&order=docdate.desc&limit=2000'),
    // Las notas de credito son las lineas CN del reporte de SAP.
    q('devoluciones', sel+'&itemcode=eq.'+en+'&order=docdate.desc&limit=2000')
      .catch(function(){ return []; })
  ]);

  var filas=[];
  (r[0]||[]).forEach(function(x){ filas.push(hviFila(x, 'IN', 1)); });
  (r[1]||[]).forEach(function(x){ filas.push(hviFila(x, 'CN', -1)); });

  HVI_ROWS=filas;
  HVI_NOMBRE=(filas[0]&&filas[0].desc)||HVI_ITEM;

  // El costo, solo si quien mira puede ver margenes. Es el promedio actual, no
  // el del dia de cada venta: SAP calcula la utilidad con el costo historico y
  // aqui no lo tenemos, asi que la cifra es aproximada y se dice.
  if(hviVerMargen()){
    try{
      var c=await q('vista_inventario','select=avgprice,lastpurprc&itemcode=eq.'+en+'&limit=1');
      var v=(c&&c[0])||{};
      HVI_COSTO=hviNum(v.avgprice)||hviNum(v.lastpurprc)||0;
    }catch(e){ HVI_COSTO=0; }
  }
}

function hviFila(x, tipo, signo){
  // La cantidad y el importe de una devolucion vienen positivos: se invierten
  // para que resten, igual que las lineas CN del reporte de SAP.
  var cant=hviNum(x.quantity)*signo;
  var imp =hviNum(x.linetotal!=null ? x.linetotal : hviNum(x.quantity)*hviNum(x.price))*signo;
  // El precio unitario real, del importe entre la cantidad: en SAP `Price` a
  // veces ya trae el descuento y a veces no.
  var pu = cant!==0 ? Math.abs(imp/cant) : hviNum(x.price);
  return {
    tipo:tipo, docnum:x.docnum,
    fecha:String(x.docdate||'').slice(0,10),
    vence:String(x.docduedate||'').slice(0,10),
    cardcode:x.cardcode||'', cliente:x.cardname||'',
    vendedor:x.nombrevendedor||'', slpcode:x.slpcode,
    desc:x.dscription||'',
    cant:cant, precio:pu, importe:imp
  };
}


/* ══════════════════════════════════════════════════════════════════════════
   PINTAR
   ══════════════════════════════════════════════════════════════════════════ */

function hviFiltradas(){
  var f=HVI_ROWS.filter(function(r){
    if(HVI_ANO && String(r.fecha).slice(0,4)!==HVI_ANO) return false;
    if(HVI_Q){
      var t=HVI_Q.toLowerCase();
      if((r.cliente+' '+r.cardcode+' '+r.vendedor+' '+r.docnum).toLowerCase().indexOf(t)<0)
        return false;
    }
    return true;
  });
  var ord={
    fecha:   function(a,b){ return String(b.fecha).localeCompare(String(a.fecha)); },
    cant:    function(a,b){ return b.cant-a.cant; },
    importe: function(a,b){ return b.importe-a.importe; },
    precio:  function(a,b){ return b.precio-a.precio; },
    cliente: function(a,b){ return String(a.cliente).localeCompare(String(b.cliente),'es'); }
  };
  return f.sort(ord[HVI_ORDEN]||ord.fecha);
}

// El panel se dibuja UNA vez. Al filtrar solo se repintan los indicadores y la
// tabla: si se rehiciera todo, el propio buscador se destruiria en cada tecla
// y perderia el foco, que es lo que pasaba antes.
function hviPintar(){
  var ov=document.getElementById('hvi-ov'); if(!ov) return;

  // Los años que existen en los datos, no una lista fija. No cambian al
  // filtrar, asi que la barra se arma una sola vez.
  var anos={}; HVI_ROWS.forEach(function(r){ var a=String(r.fecha).slice(0,4); if(a) anos[a]=1; });
  var lista=Object.keys(anos).sort().reverse();

  var h='';
  h+='<div style="max-width:1180px;margin:0 auto;padding:18px">';

  h+='<div style="display:flex;gap:12px;align-items:flex-start;flex-wrap:wrap;margin-bottom:14px">'
    +'<div style="flex:1;min-width:220px">'
      +'<div style="font-size:17px;font-weight:700">Historial de venta</div>'
      +'<div style="font-size:12.5px;color:var(--text2);margin-top:2px">'
        +'<span style="font-family:monospace">'+hviEsc(HVI_ITEM)+'</span> \u00b7 '
        +hviEsc(HVI_NOMBRE)+'</div></div>'
    +'<button class="btn btn-sm" onclick="hviCerrar()">\u2715 Cerrar</button></div>';

  h+='<div id="hvi-kpis" style="display:grid;grid-template-columns:repeat('
    +(hviVerMargen()?4:3)+',1fr);gap:10px;margin-bottom:14px"></div>';

  h+='<div class="card" style="margin-bottom:12px"><div style="display:flex;gap:8px;'
    +'flex-wrap:wrap;align-items:center">';
  h+='<input id="hvi-q" class="inp" value="'+hviEsc(HVI_Q)+'" oninput="hviSetQ(this.value)" '
    +'placeholder="Cliente, vendedor o n\u00famero de documento" style="flex:1;min-width:200px">';
  h+='<select class="inp" onchange="hviSetAno(this.value)" style="max-width:130px">'
    +'<option value="">Todos los a\u00f1os</option>'
    +lista.map(function(a){
        return '<option value="'+a+'"'+(HVI_ANO===a?' selected':'')+'>'+a+'</option>';
      }).join('')+'</select>';
  h+='<select class="inp" onchange="hviSetOrden(this.value)" style="max-width:190px">'
    +[['fecha','M\u00e1s reciente'],['cant','Mayor cantidad'],['importe','Mayor importe'],
      ['precio','Mayor precio'],['cliente','Cliente A \u2192 Z']].map(function(o){
        return '<option value="'+o[0]+'"'+(HVI_ORDEN===o[0]?' selected':'')+'>'+o[1]+'</option>';
      }).join('')+'</select>';
  h+='<button class="btn btn-sm" onclick="hviExcel()" id="hvi-xls">\ud83d\udcca Excel</button>';
  h+='<span id="hvi-cnt" style="font-size:11.5px;color:var(--text3)"></span>';
  h+='</div></div>';

  h+='<div id="hvi-tabla"></div>';
  h+='<div id="hvi-nota" style="font-size:11.5px;color:var(--text3);margin-top:10px"></div>';
  h+='<div style="height:20px"></div></div>';

  ov.innerHTML=h;
  hviRefrescar();
}

// Solo indicadores, contador y tabla. La barra de filtros no se toca.
function hviRefrescar(){
  var verM=hviVerMargen();
  var filas=hviFiltradas();

  var tCant=0, tImp=0, tUtil=0;
  filas.forEach(function(r){
    tCant+=r.cant; tImp+=r.importe;
    if(verM && HVI_COSTO>0) tUtil+=r.importe-(HVI_COSTO*r.cant);
  });
  var pct=(verM && tImp!==0)?(tUtil/tImp*100):null;

  var clientes={};
  filas.forEach(function(r){ if(r.cardcode) clientes[r.cardcode]=1; });

  var k=document.getElementById('hvi-kpis');
  if(k){
    var kh=hviKpi('Vendido', hviN(tCant)+' und')
      +hviKpi('Importe', hviMon(tImp))
      +hviKpi('Clientes', String(Object.keys(clientes).length));
    if(verM){
      kh+=hviKpi('Utilidad', HVI_COSTO>0
        ? (hviMon(tUtil)+' <span style="font-size:12px;color:var(--text3)">('
           +(pct!=null?pct.toFixed(1):'0')+'%)</span>')
        : '<span style="font-size:13px;color:var(--text3)">sin costo</span>');
    }
    k.innerHTML=kh;
  }

  var c=document.getElementById('hvi-cnt');
  if(c) c.textContent=filas.length+' documento(s)';

  var t=document.getElementById('hvi-tabla');
  if(t) t.innerHTML=hviTabla(filas, verM, tCant, tImp, tUtil, pct);

  var n=document.getElementById('hvi-nota');
  if(n){
    n.innerHTML=(verM && HVI_COSTO>0)
      ? ('La utilidad usa el costo promedio actual ('+hviMon(HVI_COSTO)+'), no el del d\u00eda '
         +'de cada venta. SAP calcula con el costo hist\u00f3rico, as\u00ed que en ventas '
         +'antiguas el n\u00famero es aproximado.')
      : '';
  }
}

function hviTabla(filas, verM, tCant, tImp, tUtil, pct){
  var h='<div class="card" style="padding:0;overflow:hidden"><div style="overflow-x:auto">';
  h+='<table class="tbl" style="margin:0;min-width:'+(verM?940:800)+'px">';
  h+='<tr><th>Documento</th><th>Cliente</th><th>Vendedor</th><th>Fecha</th><th>Vence</th>'
    +'<th style="text-align:right">Cant.</th><th style="text-align:right">Precio</th>'
    +'<th style="text-align:right">Importe</th>'
    +(verM?'<th style="text-align:right">Utilidad</th><th style="text-align:right">%</th>':'')
    +'</tr>';

  if(!filas.length){
    h+='<tr><td colspan="'+(verM?10:8)+'" style="text-align:center;padding:26px;'
      +'color:var(--text3)">Este art\u00edculo no registra ventas con estos filtros.</td></tr>';
  }

  filas.forEach(function(r){
    var neg=(r.cant<0);
    var util=(verM&&HVI_COSTO>0)?(r.importe-HVI_COSTO*r.cant):null;
    var p=(util!=null&&r.importe!==0)?(util/r.importe*100):null;
    h+='<tr'+(neg?' style="background:rgba(220,38,38,.06)"':'')+'>';
    h+='<td style="white-space:nowrap"><span style="font-size:10.5px;font-weight:700;'
      +'padding:1px 5px;border-radius:4px;background:'+(neg?'#FCEBEB':'#E6F1FB')+';color:'
      +(neg?'#791F1F':'#0C447C')+'">'+r.tipo+'</span> '
      +(neg
        ? ('<span style="color:var(--text2)">'+hviEsc(r.docnum)+'</span>')
        : ('<span style="color:var(--blue2);cursor:pointer" '
           +'onclick="hviIrFactura('+r.docnum+')"><u>'+hviEsc(r.docnum)+'</u></span>'))
      +'</td>';
    h+='<td style="font-size:12.5px"><span style="color:var(--blue2);cursor:pointer" '
      +'onclick="hviIrCliente(\''+String(r.cardcode).replace(/'/g,"\\'")+'\')">'
      +hviEsc(r.cliente||r.cardcode)+'</span></td>';
    h+='<td style="font-size:12px">'+hviEsc(r.vendedor)+'</td>';
    h+='<td style="white-space:nowrap;font-size:12px">'+hviFecha(r.fecha)+'</td>';
    h+='<td style="white-space:nowrap;font-size:12px;color:var(--text3)">'+hviFecha(r.vence)+'</td>';
    h+='<td style="text-align:right;font-weight:700'+(neg?';color:#DC2626':'')+'">'
      +hviN(r.cant,2)+'</td>';
    h+='<td style="text-align:right">'+hviMon(r.precio)+'</td>';
    h+='<td style="text-align:right;font-weight:700'+(neg?';color:#DC2626':'')+'">'
      +hviMon(r.importe)+'</td>';
    if(verM){
      h+='<td style="text-align:right">'+(util!=null?hviMon(util):'\u2014')+'</td>';
      h+='<td style="text-align:right;font-size:12px;color:'
        +(p==null?'var(--text3)':(p<15?'#B45309':'#15803D'))+'">'
        +(p!=null?p.toFixed(1):'\u2014')+'</td>';
    }
    h+='</tr>';
  });

  h+='<tr style="border-top:2px solid var(--border);font-weight:700">'
    +'<td colspan="5" style="text-align:right">Total</td>'
    +'<td style="text-align:right">'+hviN(tCant,2)+'</td><td></td>'
    +'<td style="text-align:right">'+hviMon(tImp)+'</td>'
    +(verM?('<td style="text-align:right">'+(HVI_COSTO>0?hviMon(tUtil):'\u2014')+'</td>'
           +'<td style="text-align:right">'+(pct!=null&&HVI_COSTO>0?pct.toFixed(1):'\u2014')+'</td>'):'')
    +'</tr>';
  h+='</table></div></div>';
  return h;
}

// El panel se dibuja a pantalla completa con z-index alto, asi que si se
// navega sin cerrarlo la factura se abre DEBAJO y parece que el clic no hizo
// nada. Hay que cerrarlo primero.
//
// Y de paso se deja el historial como punto de retorno: al pulsar Volver en la
// factura se vuelve aqui, no a la ficha del articulo vacia.
function hviIrFactura(docnum){
  var item=HVI_ITEM;
  hviCerrar();
  try{ VISTA_ACTUAL=function(){ hviVolver(item); }; }catch(e){}
  try{ verFactura(docnum); }catch(e){}
}
function hviIrCliente(cardcode){
  var item=HVI_ITEM;
  hviCerrar();
  try{ VISTA_ACTUAL=function(){ hviVolver(item); }; }catch(e){}
  try{ verCliente(cardcode); }catch(e){}
}
// Deja debajo la ficha del articulo y vuelve a abrir el historial encima, que
// es de donde salio el usuario.
function hviVolver(item){
  try{ if(typeof verItem==='function') verItem(item, true); }catch(e){}
  setTimeout(function(){ hviAbrir(item); }, 120);
}

function hviKpi(t,v){
  return '<div class="kpi"><div class="kpi-lbl">'+t+'</div>'
    +'<div class="kpi-val" style="font-size:19px">'+v+'</div></div>';
}

var HVI_T=null;
function hviSetQ(v){ HVI_Q=v; clearTimeout(HVI_T); HVI_T=setTimeout(hviRefrescar,200); }
function hviSetAno(v){ HVI_ANO=v; hviRefrescar(); }
function hviSetOrden(v){ HVI_ORDEN=v; hviRefrescar(); }


/* ══════════════════════════════════════════════════════════════════════════
   EXCEL
   ══════════════════════════════════════════════════════════════════════════ */

async function hviExcel(){
  if(typeof xlsxExport!=='function'){ alert('El generador de Excel no est\u00e1 disponible.'); return; }
  var b=document.getElementById('hvi-xls');
  var prev=b?b.innerHTML:null;
  if(b){ b.disabled=true; b.textContent='Generando\u2026'; }
  try{
    var verM=hviVerMargen();
    var filas=hviFiltradas();
    if(!filas.length){ alert('No hay nada que exportar con estos filtros.'); return; }

    var cols=[
      {label:'Tipo',      key:'tipo',     width:8},
      {label:'Documento', key:'docnum',   width:12, numFmt:'0'},
      {label:'C\u00f3digo',key:'cardcode',width:14},
      {label:'Cliente',   key:'cliente',  width:36},
      {label:'Vendedor',  key:'vendedor', width:18},
      {label:'Fecha',     key:'__f',      width:13},
      {label:'Vence',     key:'__v',      width:13},
      {label:'Cantidad',  key:'cant',     width:12, numFmt:'#,##0.00'},
      {label:'Precio',    key:'precio',   width:12, numFmt:'0.0000'},
      {label:'Importe',   key:'importe',  width:14, numFmt:'#,##0.00'}
    ];
    if(verM) cols=cols.concat([
      {label:'Utilidad',  key:'__u',      width:13, numFmt:'#,##0.00'},
      {label:'%',         key:'__p',      width:9,  numFmt:'0.00'}
    ]);

    await xlsxExport({
      filename:'historial-venta-'+String(HVI_ITEM).replace(/[^A-Za-z0-9_-]/g,'')+'.xlsx',
      titulo:'HISTORIAL DE VENTA \u00b7 '+HVI_ITEM+' \u00b7 '+HVI_NOMBRE,
      subtitulo:(HVI_ANO?('A\u00f1o '+HVI_ANO+'  \u00b7  '):'')
        +filas.length+' documento(s)'
        +(verM&&HVI_COSTO>0?('  \u00b7  costo promedio '+hviMon(HVI_COSTO)):''),
      columns:cols, rows:filas,
      valueFn:function(r,k){
        if(k==='__f') return hviFecha(r.fecha);
        if(k==='__v') return hviFecha(r.vence);
        if(k==='__u') return (HVI_COSTO>0)?(r.importe-HVI_COSTO*r.cant):'';
        if(k==='__p'){
          if(!(HVI_COSTO>0) || r.importe===0) return '';
          return (r.importe-HVI_COSTO*r.cant)/r.importe*100;
        }
        if(k==='cant'||k==='precio'||k==='importe') return hviNum(r[k]);
        if(k==='docnum') return hviNum(r.docnum);
        return r[k]==null?'':r[k];
      }
    });
  }catch(e){
    alert('No se pudo generar el Excel: '+(e&&e.message?e.message:e));
  }finally{
    if(b){ b.disabled=false; b.innerHTML=prev; }
  }
}
